export default function(store) {
  return store.getters['auth/IS_AUTH'];
};